import CDialog from '01_core/components/materials/CDialog';
import InhitsiteIcon from '01_core/components/materials/InhitsiteIcon';
import BizIcon from '01_core/components/materials/BizIcon'; 
import ResourceHtml from '01_core/components/materials/ResourceHtml';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withRouter } from '01_core/components/system/CustomRouter';
import ErrorCatchRoute from '01_core/components/system/ErrorCatchRoute';
import SystemError from '01_core/components/system/SystemError';
import { LABEL } from '01_core/constants/labelConsts';
import { STRING_CONSTS } from '01_core/constants/stringConsts';
import { TYPES_LOGIN_INFO, coreLoginInfoActions } from '01_core/reducers/coreLoginInfoActions';
import HomeDisplaySettingContainer from '13_usercustom/homedisplaysetting/HomeDisplaySettingContainer';
import PersonalRegisterContainer from '13_usercustom/personalregister/PersonalRegisterContainer';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import LinearProgress from '@mui/material/LinearProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import withResponsive from '01_core/hooks/withResponsive';
import DataIcon from '@mui/icons-material/Build';
import { default as DocumentIcon } from '@mui/icons-material/Description';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import LinkIcon from '@mui/icons-material/Link';
import BcmReviewIcon from '@mui/icons-material/Forum';
import DashboardIcon from '@mui/icons-material/Home';
import AnpiIcon from '@mui/icons-material/HowToReg';
import NoticeIcon from '@mui/icons-material/Info';
import MenuBcpTargetJigyoIcon from '@mui/icons-material/LibraryBooks';
import PandeIcon from '@mui/icons-material/LocalHospital';
import BcpIcon from '@mui/icons-material/LocationCity';
import GroupIcon from '@mui/icons-material/People';
import MenuKansaIcon from '@mui/icons-material/PlaylistAddCheck';
import BcmBcpIcon from '@mui/icons-material/RateReview';
import BcmKunrenIcon from '@mui/icons-material/Streetview';
import DownloadIcon from '@mui/icons-material/SystemUpdate';
import DisasterIcon from '@mui/icons-material/WarningRounded';

import { documentLinkActions } from '../common/documentLink';
import { menuLinkActions } from '../common/systemLink';
import Home from '../home/Home';
import DummyContent from './components/DummyContent';
import MenuItem from './components/MenuItem';
import MenuListItem from './components/MenuListItem';

// 機能追加時に追加する
const FAQContainer = React.lazy(() => import('../faq/FAQContainer'));
const DisasterRegisterContainer = React.lazy(() => import('12_masterdata/disasterregister/DisasterRegisterContainer'));
const DisasterSearchContainer = React.lazy(() => import('12_masterdata/disastersearch/DisasterSearchContainer'));
const GroupSearchContainer = React.lazy(() => import('12_masterdata/groupsearch/GroupSearchContainer'));
const GroupRegisterContainer = React.lazy(() => import('12_masterdata/groupregister/GroupRegisterContainer'));
const RightusageContainer = React.lazy(() => import('12_masterdata/rightusage/RightusageContainer'));
const BizExclusionContainer = React.lazy(() => import('12_masterdata/bizexclusion/BizExclusionContainer'));
const SiteRegisterContainer = React.lazy(() => import('12_masterdata/siteRegister/SiteRegisterContainer'));
const BuildingRegisterContainer = React.lazy(() => import('12_masterdata/buildingregister/BuildingRegisterContainer'));
const BuildingSearchContainer = React.lazy(() => import('12_masterdata/buildingsearch/BuildingSearchContainer'));
const SiteSearchContainer = React.lazy(() => import('12_masterdata/siteSearch/SiteSearchContainer'));
const BizUserRegisterContainer = React.lazy(() => import('12_masterdata/bizuserregister/BizUserRegisterContainer'));
const BizUserSearchContainer = React.lazy(() => import('12_masterdata/bizusersearch/BizUserSearchContainer'));
const SiteOrderingContainer = React.lazy(() => import('12_masterdata/siteordering/SiteOrderingContainer'));
const AreaSearchContainer = React.lazy(() => import('12_masterdata/areasearch/AreaSearchContainer'));
const AreaRegisterContainer = React.lazy(() => import('12_masterdata/arearegister/AreaRegisterContainer'));
const AreaOrderingContainer = React.lazy(() => import('12_masterdata/areaordering/AreaOrderingContainer'));
const BizUserCsvUploadContainer = React.lazy(() => import('12_masterdata/bizusercsvupload/BizUserCsvUploadContainer'));
const HrLinkageSearchContainer = React.lazy(() => import('12_masterdata/hrlinkagesearch/HrLinkageSearchContainer'));
const PandeReportContainer = React.lazy(() => import('22_pande/report/PandeReportContainer'));
const PandeSearchContainer = React.lazy(() => import('22_pande/search/PandeSearchContainer'));
const PandeTotalizeContainer = React.lazy(() => import('22_pande/totalize/PandeTotalizeContainer'));
const PandeMailTemplateContainer = React.lazy(() => import('22_pande/mailtemplate/PandeMailTemplateContainer'));
const PandeAuthorizeContainer = React.lazy(() => import('22_pande/authorize/PandeAuthorizeContainer'));
const GroupHisaiRegisterContainer = React.lazy(() => import('23_grouphisai/register/GroupHisaiRegisterContainer'));
const GroupHisaiSearchContainer = React.lazy(() => import('23_grouphisai/search/GroupHisaiSearchContainer'));
const GroupHisaiSortContainer = React.lazy(() => import('23_grouphisai/sort/GroupHisaiSortContainer'));
const NoticeRegisterContainer = React.lazy(() => import('24_notice/register/NoticeRegisterContainer'));
const NoticeHistoryContainer = React.lazy(() => import('24_notice/history/NoticeHistoryContainer'));
const KansaTargetRegisterContainer = React.lazy(() =>
  import('32_kansa/kansaTargetRegister/KansaTargetRegisterContainer'),
);
const KansaResultContainer = React.lazy(() => import('32_kansa/kansaResult/KansaResultContainer'));
const KansaTargetListContainer = React.lazy(() => import('32_kansa/targetlist/KansaTargetListContainer'));
const KansaReportContainer = React.lazy(() => import('32_kansa/report/KansaReportContainer'));
const KansaProgressContainer = React.lazy(() => import('32_kansa/progress/KansaProgressContainer'));
const KansaAnswerContainer = React.lazy(() => import('32_kansa/kansaanswer/KansaAnswerContainer'));
const BcpFormulationContainer = React.lazy(() => import('31_bcm/bcpformulation/BcpFormulationContainer'));
const KunrenContainer = React.lazy(() => import('31_bcm/kunren/KunrenContainer'));
const ReviewContainer = React.lazy(() => import('31_bcm/review/ReviewContainer'));
const BcmPermissionSettingContainer = React.lazy(() => import('31_bcm/setting/BcmPermissionSettingContainer'));
const BcmTargetRegisterContainer = React.lazy(() => import('31_bcm/bcmTargetRegister/BcmTargetRegisterContainer'));
const BcmTargetSearchContainer = React.lazy(() => import('31_bcm/targetSearch/BcmTargetSearchContainer'));

//表示するアイコン
const icons = {
  menu_anpi: AnpiIcon,
  menu_notice: NoticeIcon,
  menu_grouphisai: BcpIcon,
  menu_pande: PandeIcon,
  menu_masterdata_disaster: DisasterIcon,
  menu_masterdata_maint: DataIcon,
  menu_masterdata_group: GroupIcon,
  menu_document: DocumentIcon,
  menu_link: LinkIcon,
  menu_download: DownloadIcon,
  menu_bcp_system_link: FilterNoneIcon,
  menu_bcp_target_jigyo: MenuBcpTargetJigyoIcon,
  bcm_bcp: BcmBcpIcon,
  bcm_kunren: BcmKunrenIcon,
  bcm_review: BcmReviewIcon,
  menu_kansa: MenuKansaIcon,
  menu_masterdata_site_building: InhitsiteIcon,
  menu_masterdata_pande: PandeIcon,
  menu_masterdata_biz: BizIcon,
};

const documentInfoFunctionIds = ['documentlink_safety_criteria'];

const menuWidth = 310;

const AccentTypography = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.accent.main,
  color: theme.palette.accent.contrastText,
  paddingLeft: 8,
  paddingTop: 4,
  paddingBottom: 4,
}));

const StyledList = styled(List)(() => ({
  paddingTop: 0,
  paddingBottom: 0,
}));

const DividerStyled = styled(Divider)(() => ({
  height: 1,
}));

const NestedDividerStyled = styled(Divider)(({ theme }) => ({
  marginLeft: theme.spacing(4),
}));

const AdditionalMenuItem = styled('div')(() => ({
  width: '100%',
}));

const AdditionalMenuItemButton = styled(Button)(({ theme }) => ({
  display: 'block',
  marginLeft: 'auto',
  marginRight: 0,
  paddingTop: 0,
  paddingRight: 0,
  fontWeight: 'normal',
  fontSize: theme.typography.fontSize * 0.8,
  color: theme.palette.secondary.contrastText,
  textAlign: 'right',
}));

const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  paddingTop: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

const MenuItemLv2 = styled(MenuItem)(() => ({
  paddingTop: 8,
  paddingBottom: 8,
}));

const MenuListItemLv2 = styled(MenuListItem)(({ theme }) => ({
  paddingTop: 8,
  paddingBottom: 8,
  color: theme.palette.primary.main,
}));

const MenuListItemLv3 = styled(MenuListItem)(({ theme }) => ({
  paddingLeft: theme.spacing(6),
}));

export class MenuBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenPrivacyPolicy: false,
      isOpenPrecautions: false,
    };
  }

  componentDidUpdate(prevProps) {
    // メニュー開閉やモバイル切替時にAutoSizerの再計測を促す
    if (prevProps.open !== this.props.open || prevProps.mobile !== this.props.mobile) {
      setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
    }
  }

  menuList = (menuData) => {
    return menuData.map((menuItems, i) => {
      return this.isDispChirdren(menuItems.childs) ? (
        <React.Fragment key={i + 'Lv1'}>
          {menuItems.fid && (
            <AccentTypography align='left'>
              {this.props.intl.formatMessage({ id: 'menu.' + menuItems.fid })}
            </AccentTypography>
          )}
          {this.menuListLv2(menuItems.childs)}
        </React.Fragment>
      ) : (
        ''
      );
    });
  };

  menuListLv2 = (menuData) => {
    const { loginUserInfo, systemLink, documentLink, callAPIRawResponse, openInfoBar, intl } = this.props;
    return (
      <div>
        <StyledList>
          {menuData.map(({ fid, acd, childs, pms }, i) => {
            let onClick;
            try {
              if (acd === '2') {
                if (documentInfoFunctionIds.indexOf(fid) > -1) {
                  onClick = documentLinkActions[fid](callAPIRawResponse, documentLink, openInfoBar, intl);
                } else {
                  onClick = menuLinkActions[fid](pms, loginUserInfo, systemLink);
                }
              }
            } catch (e) {
              onClick = () => {};
            }

            return acd !== '0' || childs.length ? (
              <React.Fragment key={i + 'Lv2'}>
                <DividerStyled />
                <MenuListItemLv2
                  name={fid}
                  actionCd={acd}
                  onClick={onClick}
                  Icon={icons[fid]}
                  closeMenuBar={this.props.closeMenuBar}
                >
                  {childs && this.menuListLv3(childs)}
                </MenuListItemLv2>
              </React.Fragment>
            ) : (
              ''
            );
          })}
        </StyledList>
        <DividerStyled />
      </div>
    );
  };

  menuListLv3 = (menuData) => {
    const { loginUserInfo, systemLink, documentLink, callAPIRawResponse, openInfoBar,  intl } = this.props;
    return (
      <div>
        <StyledList>
          {menuData.map(({ fid, acd, pms }, i) => {
            let onClick;
            try {
              if (acd === '2') {
                if (documentInfoFunctionIds.indexOf(fid) > -1) {
                  onClick = documentLinkActions[fid](callAPIRawResponse, documentLink, openInfoBar, intl);
                } else {
                  onClick = menuLinkActions[fid](pms, loginUserInfo, systemLink);
                }
              }
            } catch (e) {
              onClick = () => {};
            }

            return (
              <React.Fragment key={i + 'Lv3'}>
                <NestedDividerStyled />
                <MenuListItemLv3
                  name={fid}
                  actionCd={acd}
                  onClick={onClick}
                  icon={icons[fid]}
                  closeMenuBar={this.props.closeMenuBar}
                />
              </React.Fragment>
            );
          })}
        </StyledList>
        <DividerStyled />
      </div>
    );
  };

  isDispChirdren = (menuData) => {
    // メニューの子要素が存在する場合「true」、存在しない場合「false」を設定する
    let chirdrenFlg = false;
    menuData.forEach((menu) => {
      if (menu.acd !== '0') {
        chirdrenFlg = true;
      } else if (menu.childs.length > 0) {
        chirdrenFlg = true;
      }
    });
    return chirdrenFlg;
  };

  render() {
    const { open, intl, history, menuData, mobile, closeMenuBar, loginUserAuth } = this.props;
    const { isOpenPrivacyPolicy, isOpenPrecautions } = this.state;
    // 機能追加時に追加する
    const componentDataOrigin = {
      notice_register: {
        component: NoticeRegisterContainer,
        props: {
          btnProps: {
            label: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
            onClick: () => {
              history.push(STRING_CONSTS.ROOT_PATH);
            },
          },
        },
      },
      notice_history: {
        component: NoticeHistoryContainer,
        props: {
          backText: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
          onBack: () => {
            history.push(STRING_CONSTS.ROOT_PATH);
          },
        },
      },
      usercustom_home_display_setting: {
        component: HomeDisplaySettingContainer,
      },
      usercustom_personal_register: {
        component: PersonalRegisterContainer,
        props: { onBack: () => history.push(STRING_CONSTS.ROOT_PATH) },
      },
      common_faq: { component: FAQContainer },
      grouphisai_register: { component: GroupHisaiRegisterContainer },
      grouphisai_search: { component: GroupHisaiSearchContainer },
      grouphisai_sort: { component: GroupHisaiSortContainer },
      pande_report: { component: PandeReportContainer },
      pande_search: { component: PandeSearchContainer },
      pande_totalize: { component: PandeTotalizeContainer },
      pande_mail_template: { component: PandeMailTemplateContainer },
      pande_authorize: { component: PandeAuthorizeContainer },
      masterdata_disaster_register: {
        component: DisasterRegisterContainer,
        props: {
          btnProps: {
            backText: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
            onBack: () => () => {
              history.push(STRING_CONSTS.ROOT_PATH);
            },
          },
        },
      },
      masterdata_disaster_search: { component: DisasterSearchContainer },
      masterdata_right_usage: { component: RightusageContainer },
      masterdata_biz_exclusion_settin: { component: BizExclusionContainer },
      masterdata_group_search: { component: GroupSearchContainer },
      masterdata_group_register: { component: GroupRegisterContainer },
      masterdata_site_register: {
        component: SiteRegisterContainer,
        props: {
          btnProps: {
            backText: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
            onBack: () => () => {
              history.push(STRING_CONSTS.ROOT_PATH);
            },
          },
          action: 'register',
        },
      },
      masterdata_building_register: {
        component: BuildingRegisterContainer,
        props: {
          btnProps: {
            backText: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
            onBack: () => () => {
              history.push(STRING_CONSTS.ROOT_PATH);
            },
          },
          action: 'register',
        },
      },
      masterdata_area_register: {
        component: AreaRegisterContainer,
        props: {
          btnProps: {
            backText: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
            onBack: () => () => {
              history.push(STRING_CONSTS.ROOT_PATH);
            },
          },
          action: 'register',
        },
      },
      masterdata_building_search: { component: BuildingSearchContainer },
      masterdata_site_search: { component: SiteSearchContainer },
      masterdata_site_ordering: { component: SiteOrderingContainer },
      masterdata_area_search: { component: AreaSearchContainer },
      masterdata_area_ordering: { component: AreaOrderingContainer },
      masterdata_hr_linkage_search: { component: HrLinkageSearchContainer },
      masterdata_biz_user_register: { 
        component: BizUserRegisterContainer,
        props: {
          btnProps: {
            backText: intl.formatMessage({ id: LABEL.CORE_TO_RETURN_HOME }),
            onBack: () => () => {
              history.push(STRING_CONSTS.ROOT_PATH);
            },
          },
          action: 'register',
        },
      },
      masterdata_biz_user_search: { component:BizUserSearchContainer },
      masterdata_biz_user_csv_upload: { component: BizUserCsvUploadContainer },
      kansa_progress: { component: KansaProgressContainer },
      kansa_target_register: { component: KansaTargetRegisterContainer },
      kansa_result: { component: KansaResultContainer },
      kansa_target_list: { component: KansaTargetListContainer },
      kansa_report: { component: KansaReportContainer },
      kansa_answer: { component: KansaAnswerContainer },
      bcm_bcp: { component: BcpFormulationContainer },
      bcm_kunren: { component: KunrenContainer },
      bcm_review: { component: ReviewContainer },
      bcm_permission_setting: { component: BcmPermissionSettingContainer },
      bcm_target_register: { component: BcmTargetRegisterContainer },
      bcm_target_search: { component: BcmTargetSearchContainer },
    };

    // 表示するメニューのみでルーターを構成する
    const componentData = {};
    const keyCheck = (menuData) =>
      menuData.forEach((menu) => {
        if (!componentData[menu.fid] && menu.acd === '1' && componentDataOrigin[menu.fid]) {
          componentData[menu.fid] = {
            ...componentDataOrigin[menu.fid],
            pms: menu.pms,
          };
        }
        if (menu.childs) {
          keyCheck(menu.childs);
        }
      });
    keyCheck(menuData);

    return (
      <div>
        <Drawer
          variant={mobile ? 'temporary' : 'permanent'}
          open={open}
          ModalProps={{
            onClose: closeMenuBar,
          }}
          sx={(theme) => ({
            '& .MuiDrawer-paper': {
              display: mobile ? 'block' : open ? 'block' : 'none',
              width: menuWidth,
              height: 'auto',
              top: mobile ? 56 : 50,
              bottom: 0,
              maxWidth: menuWidth,
              backgroundColor: theme.palette.secondary.main,
            },
          })}
        >
          <div id='menu'>
            <MenuItemLv2
              Icon={DashboardIcon}
              menuText={intl.formatMessage({ id: LABEL.CORE_HOME })}
              onClick={() => {
                // メニュークリック時は必ずダミーのコンポーネントを呼ぶ
                this.props.history.push('/rendering?');
                closeMenuBar();
              }}
            />
            {menuData && this.menuList(menuData.filter((menu) => menu.fid.startsWith('menu')))}
            {loginUserAuth.authFlg === 0 ? (
              <ListItem>
                <AdditionalMenuItem>
                  <AdditionalMenuItemButton
                    onClick={() => {
                      if (document.activeElement) { document.activeElement.blur(); }
                      this.setState({ isOpenPrivacyPolicy: true });
                    }}
                  >
                    {intl.formatMessage({
                      id: LABEL.CORE_PERSONAL_INFORMATION_HANDLING_POLICY,
                    })}
                  </AdditionalMenuItemButton>
                  <AdditionalMenuItemButton
                    onClick={() => {
                      if (document.activeElement) { document.activeElement.blur(); }
                      this.setState({ isOpenPrecautions: true });
                    }}
                  >
                    {intl.formatMessage({ id: LABEL.COMMON_PRECAUTIONS })}
                  </AdditionalMenuItemButton>
                </AdditionalMenuItem>
              </ListItem>
            ) : null}
          </div>

          <CDialog
            open={isOpenPrecautions}
            title={intl.formatMessage({ id: LABEL.COMMON_PRECAUTIONS })}
            handleClose={() => {
              this.setState({ isOpenPrecautions: false });
            }}
            fullWidth={false}
          >
            <DialogContent sx={{ marginTop: 2 }}>
              <ResourceHtml id={intl.formatMessage({ id: LABEL.COMMON_DISASTER_GUIDELIN })} />
            </DialogContent>
          </CDialog>
          <CDialog
            open={isOpenPrivacyPolicy}
            title={intl.formatMessage({
              id: LABEL.CORE_PERSONAL_INFORMATION_HANDLING_POLICY,
            })}
            handleClose={() => {
              this.setState({ isOpenPrivacyPolicy: false });
            }}
            fullWidth={false}
          >
            <DialogContent sx={{ marginTop: 2 }}>
              <ResourceHtml id='privacy_policy' />
            </DialogContent>
          </CDialog>
        </Drawer>
        <Main
          sx={(theme) => ({
            paddingLeft: open && !mobile ? `calc(${menuWidth}px + ${theme.spacing(1)})` : theme.spacing(1),
          })}
        >
          <Switch>
            <ErrorCatchRoute
              key='home'
              exact
              path={STRING_CONSTS.ROOT_PATH}
              render={() => {
                return (
                  <React.Suspense
                    fallback={
                      <LinearProgress
                        color='secondary'
                        sx={{ position: 'absolute', top: 50, left: 0, margin: 0, padding: 0, height: 4, width: '100%' }}
                      />
                    }
                  >
                    <Home menuState={open} mobile={mobile} />
                  </React.Suspense>
                );
              }}
            />
            <ErrorCatchRoute key='error' exact path='/error' component={SystemError} />
            <ErrorCatchRoute key='rendering' path='/rendering' render={() => <DummyContent />} />
            {Object.keys(componentData).map((key, i) => {
              const Component = componentData[key].component;
              return (
                <ErrorCatchRoute
                  path={STRING_CONSTS.ROOT_PATH + key}
                  render={() => {
                    return (
                      <React.Suspense
                        fallback={
                          <LinearProgress
                            color='secondary'
                            sx={{ position: 'absolute', top: 50, left: 0, margin: 0, padding: 0, height: 4, width: '100%' }}
                          />
                        }
                      >
                        <Component {...componentData[key].props} pms={componentData[key].pms} fid={key} />
                      </React.Suspense>
                    );
                  }}
                  key={i}
                />
              );
            })}
          </Switch>
        </Main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  systemLink: state.coreLoginInfo.systemLink,
  documentLink: state.coreLoginInfo.documentLink,
  loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
  loginUserAuth: state.coreLoginInfo.loginUser.loginUserAuth,
  menuData: state.coreLoginInfo.menuData,
});

const mapDispatchToProps = (dispatch) => ({
  setMenuData: (menuData) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_MENU_DATA](menuData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withResponsive(withRouter(withCallAPI(injectIntl(MenuBar)))));